<template>
  <header class="header-wrapper">
    <div class="container global-container">
      <div class="flex-box">
        <div class="left">
          <img src="@/assets/logo/florina-2021-black.png" class="logo" alt />
        </div>
        <div class="right">
          <ul class="heder-menu">
            <li>
              <div class="item-wrapper" @click="navToHome">
                <div class="item-normal" :class="[activeTab ? 'active' : '']">
                  <svgIcon iconClass="home" class="icon" />
                  <span class="text">{{ $t("menu.home") }}</span>
                </div>
                <div class="item-active" :class="[activeTab ? 'active' : '']">
                  <svgIcon iconClass="home" class="icon" />
                  <!-- <i class="el-icon-s-home icon"></i> -->
                  <span class="text">{{ $t("menu.home") }}</span>
                </div>
              </div>
            </li>
            <li @click="editPassord">
              <div class="item-wrapper">
                <div class="item-normal">
                  <i class="el-icon-edit-outline icon"></i>
                  <span class="text">{{ $t("common.editPassword") }}</span>
                </div>
                <div class="item-active">
                  <i class="el-icon-edit-outline icon"></i>
                  <span class="text">{{ $t("common.editPassword") }}</span>
                </div>
              </div>
            </li>
            <li @click="caseRefresh">
              <div class="item-wrapper">
                <div class="item-normal">
                  <!-- <i class="el-icon-refresh icon"></i> -->
                  <svgIcon iconClass="Refresh" class="icon" />
                  <span class="text">{{ $t("common.refresh") }}</span>
                </div>
                <div class="item-active">
                  <svgIcon iconClass="Refresh" class="icon" />
                  <!-- <i class="el-icon-refresh icon"></i> -->
                  <span class="text">{{ $t("common.refresh") }}</span>
                </div>
              </div>
            </li>
            <li>
              <div class="item-wrapper">
                <div class="item-normal">
                  <svgIcon iconClass="user" class="icon" />
                  <span class="text">{{ name }}</span>
                </div>
                <div class="item-active" @click="handelLogout">
                  <span class="text">{{ $t("login.logout") }}</span>
                </div>
              </div>
            </li>
            <!-- <li>
								<div class="item-wrapper">
									<div class="item-normal">
										<span class="title">{{$t('user.account')}}:</span>
										<span class="text">154784547</span>
									</div>
									<div class="item-active">
										<span class="text">154784547</span>
									</div>
								</div>
            </li>-->
            <!-- <li>
								<div class="item-wrapper">
									<span @click="languageChange('zh')" class="language" :class="whichLanguage == 'zh'?'language-active':''">中文</span>
									&nbsp;|&nbsp;
									<span @click="languageChange('en')" class="language" :class="whichLanguage == 'en'?'language-active':''">English</span>
								</div>
            </li>-->
          </ul>
        </div>
      </div>
    </div>
    <el-dialog
      class="user-detail-dialog"
      title="修改密码"
      :visible.sync="userPassWordSetDialog"
      :close-on-click-modal="false"
      width="800px"
    >
      <main>
        <EditPassword
          v-if="userPassWordSetDialog"
          @onSuccess="onPasswordEditSuccess"
        />
      </main>
    </el-dialog>
  </header>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { resetRouter } from "@/router";
import { logout } from "@/utils/auth";
import EditPassword from "@/components/EditPassword";
export default {
  name: "Fheder",
  components: { EditPassword },
  data() {
    return {
      userPassWordSetDialog: false,
    };
  },
  computed: {
    name() {
      return this.$store.getters.name !== "" ? this.$store.getters.name : "";
    },
    activeTab() {
      return this.$route.path == "/" || this.$route.path == "/dashboard";
    },
    whichLanguage() {
      return this.$i18n.locale;
    },
  },
  methods: {
    ...mapMutations({
      setPasswordDialog: "app/setPasswordDialog",
    }),
    navToHome() {
      this.$router.push({ path: "/" });
    },
    caseRefresh() {
      location.reload();
    },
    handelLogout() {
      if (logout()) {
        this.$router.push({ path: "/login" });
      }
    },
    languageChange(val) {
      this.$i18n.locale = val;
    },
    editPassord() {
      this.userPassWordSetDialog = true;
    },
    onPasswordEditSuccess() {
      this.userPassWordSetDialog = false;
      if (logout()) {
        this.$router.push({ path: "/login" });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.header-wrapper {
  width: 100%;
  height: 120px;
  background-color: #fff;
  position: relative;
  .user-detail-dialog {
    main {
      background-color: #f1f1f1;
      width: 100%;
      height: 100%;
    }
    /deep/ {
      .el-dialog__header {
        text-align: left;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
  }
  .container {
    height: 100%;
    .flex-box {
      display: flex;
      width: 100%;
      height: 100%;
      .left {
        flex: 150px 0 0;
        width: 150px;
        height: 100%;
        position: relative;
        overflow: hidden;
        .logo {
          display: block;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          max-width: 100%;
          max-height: 100%;
        }
      }
      .right {
        flex: 1;
        overflow: hidden;
      }
    }
    .heder-menu {
      margin: 0;
      padding: 0;
      width: 100%;
      font-size: 0;
      list-style-type: none;
      font-size: 14px;
      color: #333;
      box-sizing: border-box;
      text-align: right;
      margin-top: 44px;
      & li {
        min-width: 140px;
        display: inline-block;
        margin: 0 10px;
        text-align: center;
        box-sizing: border-box;
        .item-wrapper {
          margin: 0 auto;
          .item-normal,
          .item-active {
            display: block;
            padding: 8px 14px;
            opacity: 1;
            border-radius: 16px;
            transition: all 0.3s linear;
            cursor: pointer;
            .icon {
              margin-right: 5px;
              font-size: 15px;
            }
            .title {
              font-size: 15px;
              color: #000;
              margin-right: 5px;
              font-weight: 540;
            }
          }
          .item-active {
            display: none;
            opacity: 0;
            background-color: $theme_color;
          }
          &:hover .item-normal {
            display: none;
            opacity: 0;
          }
          &:hover .item-active {
            display: block;
            opacity: 1;
          }
          .active {
            background-color: $theme_color;
          }
        }
      }
    }
  }
  .language {
    cursor: pointer;
    font-size: 14px;
  }
  .language-active {
    color: $theme_color;
  }
}
// @media screen and (max-width:1200px) {
//   .header-wrapper{
//     display: none;
//   }
// }
</style>


